module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - PRODUCT - " + _vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [(_vm.id == '1140' || _vm.id == '1141' || _vm.id == '1142') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": "/static/images/product/product114_logo.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.id == '114') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": "/static/images/product/product114_logo.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.id == '118') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": "/static/images/product/product118_logo.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.id == '115' || _vm.id == '1151') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": "/static/images/product/product115_logo.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.id == '117') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": "/static/images/product/product117_logo.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.id != '1142' && _vm.id != '1141' && _vm.id != '1140' && _vm.id != '117' && _vm.id != '114' && _vm.id != '118' && _vm.id != '115' && _vm.id != '1151') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": '/static/images/product/product' + _vm.id + '_logo.png'
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('h2', {
    staticClass: "text-primary",
    staticStyle: {
      "color": "#526193 !important"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', [(_vm.id == '1140' || _vm.id == '1141' || _vm.id == '1142' || _vm.id == '114') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_1')) + ":  ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_2')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("21645-51-2")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_3')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_8')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_4')) + ": ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("281830000")])])])]) : _vm._e(), _vm._v(" "), (_vm.id == '56') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_6')) + ":  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_10')))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_7')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("70-120 ℃")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_3')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_9')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_4')) + ": ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("38123090")])])])]) : _vm._e(), _vm._v(" "), (_vm.id == '66') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.id == '63') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.id == '118') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.id == '117') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.id == '108') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.id == '70') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.id == '79') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(8)]) : _vm._e(), _vm._v(" "), (_vm.id == '59') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(9)]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_5')) + ": ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_2')))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_1')) + ":  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("BN")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_2')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("10043-11-5")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_3')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_8')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_4')) + ": ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("2850001900")])])])]) : _vm._e(), _vm._v(" "), (_vm.id == '69') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.id == '107') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.id == '106') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(12)]) : _vm._e(), _vm._v(" "), (_vm.id == '60') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(13)]) : _vm._e(), _vm._v(" "), (_vm.id == '61') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(14)]) : _vm._e(), _vm._v(" "), (_vm.id == '96') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(15)]) : _vm._e(), _vm._v(" "), (_vm.id == '71') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(16)]) : _vm._e()])])]), _vm._v(" "), (_vm.id != '1142' && _vm.id != '114' && _vm.id != '571' && _vm.id != '1151' && _vm.id != '115' && _vm.id != '57') ? _c('div', {
    staticClass: "product-sub",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("\n                    Technical Details\n                ")]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.id == '1140') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(17)]) : _vm._e(), _vm._v(" "), (_vm.id == '1141') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(18)]) : _vm._e(), _vm._v(" "), (_vm.id == '56') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(19)]) : _vm._e(), _vm._v(" "), (_vm.id == '106') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(20)]) : _vm._e(), _vm._v(" "), (_vm.id == '107') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(21)]) : _vm._e(), _vm._v(" "), (_vm.id == '59') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(22)]) : _vm._e(), _vm._v(" "), (_vm.id == '60') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(23)]) : _vm._e(), _vm._v(" "), (_vm.id == '96') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(24)]) : _vm._e(), _vm._v(" "), (_vm.id == '71') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(25)]) : _vm._e(), _vm._v(" "), (_vm.id == '66') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(26)]) : _vm._e(), _vm._v(" "), (_vm.id == '108') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(27)]) : _vm._e(), _vm._v(" "), (_vm.id == '70') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(28)]) : _vm._e(), _vm._v(" "), (_vm.id == '63') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(29)]) : _vm._e(), _vm._v(" "), (_vm.id == '69') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(30)]) : _vm._e(), _vm._v(" "), (_vm.id == '118') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(31)]) : _vm._e(), _vm._v(" "), (_vm.id == '117') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(32)]) : _vm._e(), _vm._v(" "), (_vm.id == '61') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(33)]) : _vm._e(), _vm._v(" "), (_vm.id == '79') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(34)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Properties\n                ")]), _vm._v(" "), (_vm.id == '1140' || _vm.id == '1141' || _vm.id == '1142' || _vm.id == '114') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_vm._m(35), _vm._v(" "), _c('p', [_vm._v("With 20 years production experience, now ADA Aluminum Hydroxide products have stable and high standard quality, with super fine particle size up to 1um, high whiteness up to 97, and also with low impurities. Now our ATH chemicals are exporting to more than 20 countries, and widely used in all kinds of industrial applications, such as fire retardants, artificial marbles, water treatment, and so on.\n")])]) : _vm._e(), _vm._v(" "), (_vm.id == '70') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Dicyandiamide is a kind of white crystal powder,which is soluble in water and alcohol, slightly insoluble in aether and benzene, stable when dry and not flammable.")]), _vm._v(" "), _c('p', [_vm._v("It is a material of melamine and intermediate pan of syntheticdrug,pesticides and coloring agent. It can be produced guanidine nitrate,sulfanilamide,sulfocarbanide,rubber accelerator,hardening of stell,fixing agent of dyeprinting,sizing agent,compound fertilizer,etc.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '69') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Sodium acid pyrophosphate, or disodium pyrophosphate, is an edible phosphoric salt that helps create leavening used for baking, such as baking powder, and prevents food discoloration, such as in raw potatoes.")]), _vm._v(" "), _c('p', [_vm._v("In its bulk state, such as at the manufacturing laboratory, the acidic nature of sodium acid pyrophosphate may be very hazardous upon skin or eye contact, inhalation or ingestion, causing severe inflammation.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '106') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Black Silicon Carbide, also know as Black SiC, is produced in an electric resistance furnace from quartz sand and petroleum coke or anthracite at high temperature. The hardness and sharp particle of this material make it suitable for manufacturing of grinding wheels, coated products, wire saws, superior refractory materials and deoxide as well as for lapping, polishing and blasting.")]), _vm._v(" "), _c('p', [_vm._v("We are professional manufacturer of Silicon Carbide, and we are producing different grade of Silicon Carbide for all kinds of industrial applications.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Hexagonal Boron Nitride is a thermally and chemically resistant refractory compound of boron and nitrogen with the chemical formula BN. The material is anisotropic for its electrical and mechanical properties due to the platy hexagonal crystals and their orientation during the hot press consolidation.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Boron Nitride has high thermal conductivity, low thermal expansion, good thermal shock resistance, high electrical resistance, low dielectric constant and loss tangent.\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.id == '117') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("It is an organic compound and is the most prolific dicarboxylic acid. Solid at room temperature. Heating will not melt, 300℃ above sublimation. If heated in an airtight container, it melts at 427℃. Terephthalic acid is the raw material for the production of polyesters, especially polyethylene terephthalate (PET).")]), _vm._v(" "), _c('p', [_vm._v("We are professional provider of PTA materials, and our sales specialist will recommend the most suitable material for your application, and related Technical Data Sheet is available upon your request.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '63') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Azodicarbonamide blowing agent is a kind of light yellow fine powder, which is one of the most widely used chemical blowing agents due to its non-toxic, odorless, self-extinguishing, relatively high decomposition temperature, and relatively large gas evolution properties, good dispersing in plastic and rubber.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '66') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Barium sulfate is a kind of amorphous white powder or paste. It is nontoxic, insoluble in water, and slightly soluble in boiling hydrochloric acid.")]), _vm._v(" "), _c('p', [_vm._v("It is chemically stable, with a total reduction of carbon as barium sulfide. It won't change color when meeting with hydrogen sulfide or toxic gases in the air.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '79') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("It is produced by the spray drying technology and the obtained product is light yellow, corresponding liquid form products is light yellow.")]), _vm._v(" "), _c('p', [_vm._v("It is a kind of high-efficient,economical and nontoxic inorganic high-molecular compound, which is easily soluble in water. And it's accompanied with many chemical processes such as electrochemistry,coagulation, absorption and precipitation during the hydrolyzation .")])]) : _vm._e(), _vm._v(" "), (_vm.id == '56') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Magnesium hydroxide is a white powder which is nontoxic, odorless, non-corrosion and with good flame retarding effect. It has good stability, decomposition temperature is about 330, especially suitable for resin processed in relative high temperature. Large amount of vapor is produced during combustion, the heat is taken away and the temperature drops. The hardness is less than that of aluminum hydroxide.")]), _vm._v(" "), _c('p', [_vm._v("According to different applications, we are offering a wide range types of magnesium hydroxide, with different particle size\\whiteness, and we can also offer natural grade or coated types as requested.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '107') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("It is a protection coating material used in metal casting equipment and equipment molds, which has good adhesion ability for metal or ceramic materials, and to provide the most effective lubrication and protection of the interface.")]), _vm._v(" "), _c('p', [_vm._v("Boron Nitride Coating is made by boron nitride materials by unique formula, which can achieve excellent performance in high temperature metal protection, effectively prevent the molten metal from corrosion, extend the service life of equipment and various tools, reduce the production cost.")]), _vm._v(" "), _c('p', [_vm._v("We are professional manufacturer of Boron Nitride coating materials, and we are producing different grade of products for all kinds of industrial applications.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '96') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Nano calcium carbonate is also called super fine calcium carbonate .It can provide some excellent functions during polymer production such as improving the hardness of the polymer, improving strength (tensile and impact) and enhancing the surface whiteness and gloss finish.")]), _vm._v(" "), _c('p', [_vm._v("At the same time, it can also greatly reduce the cost during the production of plastic and rubber products.")]), _vm._v(" "), _c('p', [_vm._v("With it's outstanding functions, nano calcium carbonate is widely used in plastics product such as cable, pipe, masterbatch, film, sheet, etc. And also used in Paint & coating,paper, water treatment, etc.")]), _vm._v(" "), _c('p', [_vm._v("We are professional manufacturer of Nano calcium carbonate powders, and we are producing different grade of Nano calcium carbonate for all kinds of industrial applications.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '108') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Fumed silica is an extremely small particle with enormous surface area, high purity, and a tendency to form chains in the chemical manufacturing process.")]), _vm._v(" "), _c('p', [_vm._v("Particles are formed by injecting chlorosilanes, such as silicon tetrachloride, into a flame of hydrogen and air. The ensuring reaction produces fumed silica and hydrogen chloride.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '118') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("It is white powder, and the particle size is 60-250um. It is fire retardant and self-extinguishing, with very good chemical resistance.\n                  ")]), _vm._v(" "), _c('p', [_vm._v("It is mainly used to produce soft plastic products such as artificial leather, films, and wire sheaths, as well as hard plastic products such as plates, doors and windows, pipes and valves.\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.id == '60') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Polyethylene wax is a widely used raw materials which has low adhesive, high softening point and good hardness with stable chemical characteristics.")]), _vm._v(" "), _c('p', [_vm._v("It also has good heat stability, good dispersion performance, no poison, no frost and mucous membrane.")]), _vm._v(" "), _c('p', [_vm._v("With all the above featues, it can be used as an ideal interior & exterior lubricant, and also as a substitute for liquid paraffin, natural paraffin etc.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '71') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Optical Brightener is a kind of light yellow powder, it is hardly soluble in water, but soluble in paraffin, mineral oils and ordinary organic solvents.")]), _vm._v(" "), _c('p', [_vm._v("There are different grade of optical brighteners such as OB grade/OB-1 grade/KSN grade /etc, each type of optical brightener can be used as good whitening agent for various application products such as plastic products, paintings, paper and textiles.\n\n")])]) : _vm._e(), _vm._v(" "), (_vm.id == '59') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("CPE resin is one kind of rubber high molecular material made of high-density polythene resin after chlorination reaction, which has good mechanical and chemical properties.")]), _vm._v(" "), _c('p', [_vm._v("It is widely used in PVC plastic profile, sheet, pipe, pipe fittings, waterproof membrane, wire and cable sheathing, sealing, PVC laminated and extension of various plastics and rubber products.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("ADA PVC Stabilizers are combinations of chemical additives necessary for the production of various PVC products. The stabilizer is Lead or Ca-Zn based, and also combined with lubricants and other additives, which can achieve ideal performance both for production and final products.\n             ")]), _vm._v(" "), _c('p', [_vm._v("ADA provides different models of stabilizers for applications such as: Pipes & Fittings, Wires & Cables, Window Profiles, Flooring and Films. Please contact our sales staff, we will give more product information according to your specific technical requirements.\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.id == '61') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Calcium Stearate is a kind of white fine powder, which is insoluble in water, soluble in hot ethanol and ether. It is easy to absorb, and will be decomposed to stearic acid and the relevant calcium-salt.")]), _vm._v(" "), _c('p', [_vm._v("It is mainly performed as a good kind of PVC lubricant, and widely used in PP and PVC products.")])]) : _vm._e(), _vm._v(" "), (_vm.id != '1142' && _vm.id != '114' && _vm.id != '571' && _vm.id != '1151' && _vm.id != '57' && _vm.id != '115') ? _c('div', {
    staticClass: "product-sub"
  }, [_c('span', [_vm._v("Main Applications")])]) : _vm._e(), _vm._v(" "), (_vm.id == '1142' || _vm.id == '114') ? _c('div', {
    staticClass: "product-sub"
  }, [_c('span', [_vm._v("Technical Details")])]) : _vm._e(), _vm._v(" "), (_vm.id != '1141' && _vm.id != '1140' && _vm.id != '57' && _vm.id != '115' && _vm.id != '114' && _vm.id != '1142' && _vm.id != '571' && _vm.id != '1151') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": '/static/images/product/product' + _vm.id + '_1.png'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.id == '1141') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(36), _vm._v(" "), _c('div', {
    staticClass: "row big"
  }, [_vm._m(37), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": '/static/images/product/p1141_right.png'
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.id == '1140') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(38), _vm._v(" "), _vm._m(39)]) : _vm._e(), _vm._v(" "), (_vm.id == '1142' || _vm.id == '114') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(40), _vm._v(" "), _vm._m(41)]) : _vm._e(), _vm._v(" "), (_vm.id != '571' && _vm.id != '1151' && _vm.id != '57' && _vm.id != '115') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Packing & Delivery\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id != '1141' && _vm.id != '114' && _vm.id != '1140' && _vm.id != '115' && _vm.id != '1142' && _vm.id != '57' && _vm.id != '571' && _vm.id != '1151') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": '/static/images/product/product' + _vm.id + '_2.png'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.id == '1142' || _vm.id == '114') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(42), _vm._v(" "), _vm._m(43)]) : _vm._e(), _vm._v(" "), (_vm.id == '1141') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(44), _vm._v(" "), _c('div', {
    staticClass: "row big"
  }, [_vm._m(45), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": '/static/images/product/p1141_right_2.png'
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.id == '1140') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(46), _vm._v(" "), _vm._m(47)]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Product Details\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(48), _vm._v(" "), _vm._m(49)]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Technical Support\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(50), _vm._v(" "), _vm._m(51)]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    One-Stop Provider\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(52), _vm._v(" "), _vm._m(53)]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Technical Details\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(54), _vm._v(" "), _vm._m(55)]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Particle Distribution\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(56), _vm._v(" "), _vm._m(57)]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Main Applications\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(58), _vm._v(" "), _vm._m(59)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Sales Contact\n                ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._m(60), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 order-md-1 aos-init aos-animate",
    staticStyle: {
      "font-size": "13px !important"
    }
  }, [_c('contact', {
    attrs: {
      "productName": _vm.name
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Al(OH)"), _c('sub', [_vm._v("3")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Mg(oh)2")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("1309-48-4")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("96% min")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("BaSO4")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("7727-43-7")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("HS Code: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("2833270000")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("C2H4N4O2")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("123-77-3")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Pale yellow powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("CH2-CHCLn")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("9002-86-2")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("HS Code:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("39041000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("C8H6O4")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("100-21-0")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("EINECS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("202-830-0")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("SiO2")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("112945-52-5")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White Powder ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99.8%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("C2H4N4")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("461-58-5")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("EINECS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("207-312-8")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White crystal powder")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("[AL2(OH)LnCL6-n]m")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("1327-41-9")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("EINECS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("215-477-2")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Yellow powder")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("[CH2-CHCl-CH2-CH2]n")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("63231-66-3")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99.9%")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Na2H2P2O7")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("7758-16-9")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("EINECS: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("231-835-0")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Chemical name:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Boron Nitride Coating")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Packing:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Barrels")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White emulsion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Solid content: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("25% ~ 30%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Chemical name:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Black Silicon Carbide")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("SiC")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Black Granula")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Application: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Abrasive")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("(C2H4)n")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("9002-88-4")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White flake")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Softening Point (℃): ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("100-110")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("C36H70O4Ca")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("1592-23-0")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99.9%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("471-34-1")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("CACO3")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99% min")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Melting point: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("205-360°C")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Particle size:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("300 meshes Min")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Light yellow powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99% min")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_c('strong', [_vm._v("Category")])]), _c('td', [_c('strong', [_vm._v("Model")])]), _c('td', [_c('strong', [_vm._v("Content（%）")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Particle size（D50）")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Whiteness")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Moisture（%）")])])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Fine Grade")]), _vm._v(" "), _c('td', [_vm._v("AF-1")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("1-2 um")]), _vm._v(" "), _c('td', [_vm._v("96")]), _vm._v(" "), _c('td', [_vm._v("≤0.25")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("AF-4")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("3-5 um")]), _vm._v(" "), _c('td', [_vm._v("93-97")]), _vm._v(" "), _c('td', [_vm._v("≤0.22")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AF-8")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("8-10 um")]), _vm._v(" "), _c('td', [_vm._v("93-97")]), _vm._v(" "), _c('td', [_vm._v("≤0.20")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("High Whiteness")]), _vm._v(" "), _c('td', [_vm._v("AH-14")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("14 um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.30")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AH-25")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("25 um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.20")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("AH-50")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("50 um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.15")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AH-75")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("75 um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.15")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Normal Grade")]), _vm._v(" "), _c('td', [_vm._v("AN-W")]), _vm._v(" "), _c('td', [_vm._v("≥99.5")]), _vm._v(" "), _c('td', [_vm._v("70-90 um")]), _vm._v(" "), _c('td', [_vm._v("89")]), _vm._v(" "), _c('td', [_vm._v("3-5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AN-D")]), _vm._v(" "), _c('td', [_vm._v("≥99.5")]), _vm._v(" "), _c('td', [_vm._v("70-90 um")]), _vm._v(" "), _c('td', [_vm._v("89")]), _vm._v(" "), _c('td', [_vm._v("≤0.35")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_c('strong', [_vm._v("Category")])]), _c('td', [_c('strong', [_vm._v("Model")])]), _c('td', [_c('strong', [_vm._v("Content")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Particle size")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Whiteness")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Moisture")])])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_c('strong', [_vm._v("Fine Grade")])]), _vm._v(" "), _c('td', [_vm._v("AF-1")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("1-2um")]), _vm._v(" "), _c('td', [_vm._v("96")]), _vm._v(" "), _c('td', [_vm._v("≤0.25%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("AF-4")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("3-5um")]), _vm._v(" "), _c('td', [_vm._v("93-97")]), _vm._v(" "), _c('td', [_vm._v("≤0.22%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AF-8")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("8-10um")]), _vm._v(" "), _c('td', [_vm._v("93-97")]), _vm._v(" "), _c('td', [_vm._v("≤0.20%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "rowspan": "4"
    }
  }, [_c('strong', [_vm._v("High Whiteness")])]), _vm._v(" "), _c('td', [_vm._v("AH-14")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("14um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.30%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AH-25")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("25um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.20%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("AH-50")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("50um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.15%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AH-75")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("75um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.15%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_c('strong', [_vm._v("Normal Grade")])]), _vm._v(" "), _c('td', [_vm._v("AN-W")]), _vm._v(" "), _c('td', [_vm._v("≥99.5%")]), _vm._v(" "), _c('td', [_vm._v("70-90um")]), _vm._v(" "), _c('td', [_vm._v("89")]), _vm._v(" "), _c('td', [_vm._v("3-5%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AN-D")]), _vm._v(" "), _c('td', [_vm._v("≥99.5%")]), _vm._v(" "), _c('td', [_vm._v("70-90um")]), _vm._v(" "), _c('td', [_vm._v("89")]), _vm._v(" "), _c('td', [_vm._v("≤0.35%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical Value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Mg(OH)2 , %")]), _c('td', [_vm._v("≥94")]), _c('td', [_vm._v("96.3")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Particle Size")]), _c('td', [_vm._v("325-8000 Mesh")]), _c('td', [_vm._v("325-8000 Mesh")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Whiteness")]), _c('td', [_vm._v("≥91")]), _c('td', [_vm._v("93")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("CaO , %")]), _c('td', [_vm._v("≤ 2.0")]), _c('td', [_vm._v("0.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Hydrochloric acid insoluble，% ")]), _c('td', [_vm._v("≤ 2.0")]), _c('td', [_vm._v("0.8")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Moisture，%")]), _c('td', [_vm._v("≤ 0.5")]), _c('td', [_vm._v("0.17")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Cl， %")]), _c('td', [_vm._v("≤ 0.05")]), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Fe， %")]), _c('td', [_vm._v("≤ 1.0")]), _c('td', [_vm._v("0.1")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("75um Residue, %")]), _c('td', [_vm._v("≤ 0.01")]), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Loss on ignition，%")]), _c('td', [_vm._v("≥28")]), _c('td', [_vm._v("30")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Modification Rate, %")]), _c('td', [_vm._v("≥98")]), _c('td', [_vm._v("99.5")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Appearance")]), _c('td', [_vm._v("Black granular")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Hardness, Mohs")]), _c('td', [_vm._v(">6")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Apparent density ,kg/M3")]), _c('td', [_vm._v("3.2 x 10³")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Moisture,%")]), _c('td', [_vm._v("0.01")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("SiO2,%")]), _c('td', [_vm._v("28")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Al2O3,%")]), _c('td', [_vm._v("9.29")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Fe2O3,%")]), _c('td', [_vm._v("22.1")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("MgO,%")]), _c('td', [_vm._v("4.62")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("C")]), _c('td', [_vm._v("16.3")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Particle Size (Mesh)")]), _c('td', [_vm._v("10-20, 20-40, 20-60, or as customer required")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Main ingredients")]), _c('td', [_vm._v("Hexagonal boron nitride")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Coverage area")]), _c('td', [_vm._v("25-30m2/L")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Adhesive")]), _c('td', [_vm._v("Clay")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Viscosity")]), _c('td', [_vm._v("4000-5000CPS")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Specific gravity")]), _c('td', [_vm._v("1.2(g/㎝3)")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Solid content")]), _c('td', [_vm._v("25%~30%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Appearance")]), _c('td', [_vm._v("White emulsion")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Chlorine content, %")]), _c('td', [_vm._v("35±2")]), _c('td', [_vm._v("35.8")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Heat of fusion, j/g")]), _c('td', [_vm._v("≤2.0")]), _c('td', [_vm._v("1.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Volatile matter %")]), _c('td', [_vm._v("≤0.4")]), _c('td', [_vm._v("0.17")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Residue on sieve (mesh of 0.9mm)  %")]), _c('td', [_vm._v("≤2.0")]), _c('td', [_vm._v("0.6")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Impurity particles, pc/100g")]), _c('td', [_vm._v("≤60")]), _c('td', [_vm._v("21")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Tensile strength, Mpa")]), _c('td', [_vm._v("≥8.0")]), _c('td', [_vm._v("9")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Shore hardness")]), _c('td', [_vm._v("≤65")]), _c('td', [_vm._v("52")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Appearance")]), _c('td', [_vm._v("White flake")]), _c('td', [_vm._v("White flake")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Softening point ℃")]), _c('td', [_vm._v("90-105")]), _c('td', [_vm._v("100")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Dosage (%)")]), _c('td'), _c('td', [_vm._v("3.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Density (g/cm3)")]), _c('td', [_vm._v("0.90-0.93")]), _c('td', [_vm._v("0.91")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Average molecular weight")]), _c('td', [_vm._v("2000-2500")]), _c('td', [_vm._v("2320")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("calcium carbonate,%")]), _c('td', [_vm._v("≥ 98")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("PH value")]), _c('td', [_vm._v("8.0-10.0")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Moisture,%")]), _c('td', [_vm._v("≤0.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Whiteness")]), _c('td', [_vm._v(" ≥ 96")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Particle size")]), _c('td', [_vm._v("20-110 nm")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Fe content, %")]), _c('td', [_vm._v("≤0.08")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Mn content, %    ")]), _c('td', [_vm._v(" ≤0.006")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Surface treatment")]), _c('td', [_vm._v("stearic acid")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Oil absorption ml/100g ")]), _c('td', [_vm._v("≤35")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("E (1% /cm)         ")]), _c('td', [_vm._v("420-1200")]), _c('td', [_vm._v("420-1200(Depends on grade)")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Indissoluble substance:       ")]), _c('td', [_vm._v("0.5%max")]), _c('td', [_vm._v("0.35")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Solubility in water (25℃, g/l )")]), _c('td', [_vm._v("20-30")]), _c('td', [_vm._v("25")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Solubility in water   (70℃, g/l )")]), _c('td', [_vm._v("90-110")]), _c('td', [_vm._v("100")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Solubility in water ( (95℃, g/l ))")]), _c('td', [_vm._v("290-310")]), _c('td', [_vm._v("300")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Max in ultra-violet range")]), _c('td', [_vm._v("348-350nm")]), _c('td', [_vm._v("349 nm")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standards")]), _c('td', [_vm._v("Typical Value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Content")]), _c('td', [_vm._v("≥98.0%")]), _c('td', [_vm._v("0.982")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Water soluble matter")]), _c('td', [_vm._v("≤0.30%")]), _c('td', [_vm._v("0.0011")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Acid soluble matter")]), _c('td', [_vm._v("≤0.60%")]), _c('td', [_vm._v("confirmed")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("PH value  ")]), _c('td', [_vm._v("6.0-9.0")]), _c('td', [_vm._v("8")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Iron(Fe)")]), _c('td', [_vm._v("≤0.004%")]), _c('td', [_vm._v("4E-05")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Sulfide(S)")]), _c('td', [_vm._v("≤0.003%")]), _c('td', [_vm._v("1.5E-05")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Particle size distribution")]), _c('td', [_vm._v("Depends on grade")]), _c('td', [_vm._v("Depends on grade")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Oil absorption")]), _c('td', [_vm._v("8-25%")]), _c('td', [_vm._v("0.19")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Whiteness ")]), _c('td', [_vm._v("≥96")]), _c('td', [_vm._v("96")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Silica content(based on ignited material) ,wt%")]), _c('td', [_vm._v(">99.8%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Specific surface area (BET), m2/g   ")]), _c('td', [_vm._v("200+-15")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Carbon content(Based on drying at 105℃ for 2 hours) ,wt%")]), _c('td', [_vm._v("<0.15")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("PH-value in 4% dispersion")]), _c('td', [_vm._v("3.7-4.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Moisture loss on drying 2 hour at 105℃, wt%")]), _c('td', [_vm._v("<1.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Ignition loss 2 hours at 1000℃ based on material dried for 2 hours at 105℃, wt%")]), _c('td', [_vm._v("<2.0")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Sieve residue(45um), wt%")]), _c('td', [_vm._v("<0.04")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Tamped Density(Based on drying at 105℃ for 2 hours) ,g/L")]), _c('td', [_vm._v("40-60")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical Value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("C2H4N4 Content, %")]), _c('td', [_vm._v("≥99.5")]), _c('td', [_vm._v("99.6")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("H2O Content, %")]), _c('td', [_vm._v("≤0.30")]), _c('td', [_vm._v("0.22")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Ash Content, %")]), _c('td', [_vm._v("≤0.03")]), _c('td', [_vm._v("0.024")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("M.P. (°C)")]), _c('td', [_vm._v("209-212")]), _c('td', [_vm._v("210")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Ca Content (ppm)")]), _c('td', [_vm._v("≤200")]), _c('td', [_vm._v("95")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Appearance")]), _c('td', [_vm._v("Yellow powder")]), _c('td', [_vm._v("Yellow powder")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Gas of foaming amount(ML/G)")]), _c('td', [_vm._v("150-240")]), _c('td', [_vm._v("150-240")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Average diameter(um)")]), _c('td', [_vm._v("8.5-10")]), _c('td', [_vm._v("9")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Decomposition temperature,")]), _c('td', [_vm._v("150-220")]), _c('td', [_vm._v("150-220")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Moisture content(%)")]), _c('td', [_vm._v("0.5 max")]), _c('td', [_vm._v("0.12")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("PH")]), _c('td'), _c('td', [_vm._v("6.7")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Ash(%)")]), _c('td', [_vm._v("0.2 max")]), _c('td', [_vm._v("0.09")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Specification")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Appearance")]), _c('td', [_vm._v("White Powder")]), _c('td', [_vm._v("White Powder")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Content, %")]), _c('td', [_vm._v("≥95")]), _c('td', [_vm._v("95.33")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("PH of 1% water solution")]), _c('td', [_vm._v("3.5-5")]), _c('td', [_vm._v("3.98")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Water insoluble, %")]), _c('td', [_vm._v("≤1.0")]), _c('td', [_vm._v("0.03")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Pb, %")]), _c('td', [_vm._v("≤0.0015")]), _c('td', [_vm._v("0.001")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("As, %")]), _c('td', [_vm._v("≤0.0003")]), _c('td', [_vm._v("0.00018")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("F, %")]), _c('td', [_vm._v("≤0.005")]), _c('td', [_vm._v("0.002")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("P2O5, %")]), _c('td'), _c('td', [_vm._v("63.57")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Dryingloss %≤")]), _c('td'), _c('td', [_vm._v("0.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Bulk density")]), _c('td'), _c('td', [_vm._v("0.85")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Suspension Grade")]), _vm._v(" "), _c('td', [_vm._v("SG3")]), _vm._v(" "), _c('td', [_vm._v("SG4")]), _vm._v(" "), _c('td', [_vm._v("SG5")]), _vm._v(" "), _c('td', [_vm._v("SG6")]), _vm._v(" "), _c('td', [_vm._v("SG7")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("K value ")]), _c('td', [_vm._v("72-71")]), _c('td', [_vm._v("70-69")]), _c('td', [_vm._v("68-66")]), _c('td', [_vm._v("65-63")]), _c('td', [_vm._v("62-60")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Viscosity, ml/g ")]), _c('td', [_vm._v("135-127")]), _c('td', [_vm._v("126-119")]), _c('td', [_vm._v("118-107")]), _c('td', [_vm._v("106-96")]), _c('td', [_vm._v("95-87")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Average polymerization")]), _c('td', [_vm._v("1350-1250")]), _c('td', [_vm._v("1250-1150")]), _c('td', [_vm._v("1100-1000")]), _c('td', [_vm._v("950-850")]), _c('td', [_vm._v("950-850")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Number of impurity particle ≤")]), _c('td', [_vm._v(" 30")]), _c('td', [_vm._v(" 30")]), _c('td', [_vm._v(" 30")]), _c('td', [_vm._v(" 30")]), _c('td', [_vm._v(" 40")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Volatiles content %, ≤")]), _c('td', [_vm._v(" 0.40")]), _c('td', [_vm._v(" 0.40")]), _c('td', [_vm._v(" 0.40")]), _c('td', [_vm._v(" 0.40")]), _c('td', [_vm._v(" 0.40")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Spontaneous ignition point")]), _c('td', [_vm._v("680℃")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Burning point")]), _c('td', [_vm._v("384~421℃")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Sublimation fever")]), _c('td', [_vm._v("98.4kJ/mol")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Heat of combustion")]), _c('td', [_vm._v("3225.9kJ/mol")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Density")]), _c('td', [_vm._v("1.55g/cm3")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Calcium content, %")]), _c('td', [_vm._v("6.0-7.1")]), _c('td', [_vm._v("6.6")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Moisture, %")]), _c('td', [_vm._v("3max")]), _c('td', [_vm._v("2.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Melting Point,°C")]), _c('td', [_vm._v("140 min")]), _c('td', [_vm._v("147")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Fineness (through mesh200), %")]), _c('td', [_vm._v("95min")]), _c('td', [_vm._v("98.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Free fatty acid, %")]), _c('td', [_vm._v("0.5 Max")]), _c('td', [_vm._v("0.4")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Items")]), _c('td', [_vm._v("Specifications")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Aluminium oxide(Al2O3) % ")]), _c('td', [_vm._v("30%min")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Basicity%")]), _c('td', [_vm._v("70-90%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("PH (1% aqueous solution)")]), _c('td', [_vm._v("3.5-5.0%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Water insoluble %")]), _c('td', [_vm._v("0.001")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("(As)/%")]), _c('td', [_vm._v("≤0.0002")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("(Pb)/%")]), _c('td', [_vm._v("≤0.001")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Cd(Cd)/%")]), _c('td', [_vm._v("≤0.0002")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Cr+6 %")]), _c('td', [_vm._v("≤0.0005")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("   Hg %")]), _c('td', [_vm._v("≤0.00001")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Aluminum Hydroxide, Al(OH)"), _c('sub', [_vm._v("3")]), _vm._v(" ,also called alumina trihydrate. It has both basic and acidic properties, and closely related are aluminum oxide or alumina (Al"), _c('sub', [_vm._v("2")]), _vm._v("O"), _c('sub', [_vm._v("3")]), _vm._v("), It can be heated to 200°C and hydrated alumina can be decomposed into 66% alumina and 34% water.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "text-align": "left",
      "font-weight": "normal",
      "color": "#666"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "10px"
    }
  }, [_vm._v("Flame Retardant")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Used as flame retardant filler for PVC and Rubber products, such as wire, cable, construction material, paint, etc.\n                            ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Artificial Marble Filler")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Used as fillers for the production of Artificial Marble, Solid Surface, Stone, etc.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Raw Material")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Used as the raw material for the production of Alum, Glass, Water Treatment, etc.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_1_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_1_m.png"
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_2_m.png"
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_3_m.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_1.png"
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_2.png"
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_3.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_packing_m.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_packing.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "text-align": "left",
      "font-weight": "normal",
      "color": "#666"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "10px"
    }
  }, [_vm._v("Packing")]), _vm._v(" "), _c('p'), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("25kg,  50kg, 1000Kg bags")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("OEM packing service available")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Loading")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("One 20ft container can load")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("- 14 Tons (Super fine grade)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("- 24 Tons (Other grades)")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Shipment")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Fast production and delivery.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Professional worldwide shipment")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_2_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_1_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_2_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_3_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_3.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_1_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_2_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_3_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_3.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-md-6 order-md-2",
    staticStyle: {
      "font-size": "15px",
      "line-height": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('i', {
    staticClass: "bi bi-envelope-fill",
    staticStyle: {
      "color": "#526193",
      "margin-right": "5px"
    }
  }), _vm._v("\n                      cliff@adachemicals.com")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('i', {
    staticClass: "bi bi-telephone-fill",
    staticStyle: {
      "color": "#526193",
      "margin-right": "5px"
    }
  }), _vm._v("\n                     +86-13917648345 "), _c('span', {
    staticStyle: {
      "margin-left": "3px"
    }
  }, [_vm._v("(WhatsApp/WeChat)")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('i', {
    staticClass: "bi bi-geo-alt-fill",
    staticStyle: {
      "color": "#526193",
      "margin-right": "5px"
    }
  }), _vm._v(" Room 1208, No.36, 1200 Changqing Road, "), _c('div', {
    staticStyle: {
      "position": "relative",
      "top": "-5px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "23px"
    }
  }, [_vm._v("Pudong New Area, Shanghai")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce6e905a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product.vue
// module id = 1402
// module chunks = 1